/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Transcription } from '../models/Transcription';
import type { YouTubeParameters } from '../models/YouTubeParameters';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VideoService {
  /**
   * @returns Transcription
   * @throws ApiError
   */
  public static videoGetMyFiles(): CancelablePromise<Array<Transcription>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Video/my_files',
    });
  }

  /**
   * @param id
   * @returns Transcription
   * @throws ApiError
   */
  public static videoGet(id?: string): CancelablePromise<Transcription> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Video/get',
      query: {
        id: id,
      },
    });
  }

  /**
   * @param id
   * @returns binary
   * @throws ApiError
   */
  public static videoUnlock(id?: string): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Video/unlock',
      query: {
        id: id,
      },
    });
  }

  /**
   * @param id
   * @returns binary
   * @throws ApiError
   */
  public static videoAccept(id?: string): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Video/accept',
      query: {
        id: id,
      },
    });
  }

  /**
   * @param id
   * @returns binary
   * @throws ApiError
   */
  public static videoRefund(id?: string): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Video/refund',
      query: {
        id: id,
      },
    });
  }

  /**
   * @deprecated
   * VideoController is deprecated. If used again, consider implementing the social endpoint for tiktok and instagram.
   * @param requestBody
   * @returns binary
   * @throws ApiError
   */
  public static videoYouTube(
    requestBody: YouTubeParameters
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Video/youtube',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id
   * @returns binary
   * @throws ApiError
   */
  public static videoCreate(id?: string): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Video/create',
      query: {
        id: id,
      },
    });
  }

  /**
   * @param id
   * @returns Transcription
   * @throws ApiError
   */
  public static videoStatus(id?: string): CancelablePromise<Transcription> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Video/status',
      query: {
        id: id,
      },
    });
  }

  /**
   * @param id
   * @returns binary
   * @throws ApiError
   */
  public static videoDownload(id?: string): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Video/download',
      query: {
        id: id,
      },
    });
  }
}
